import { StateCreator } from "zustand";

// --- State Type ---
export type SupportSliceState = {
  isSheetOpen: boolean;
  sheetArticleId: string | null;
};

// --- Actions Type ---
export type SupportSliceActions = {
  openSheet: (articleId: string) => void;
  closeSheet: () => void;
  setSheetArticleId: (articleId: string) => void;
};

// --- Combined Type ---
export type SupportSlice = SupportSliceState & SupportSliceActions;

// --- Initial State ---
export const initialSupportState: SupportSliceState = {
  isSheetOpen: false,
  sheetArticleId: null,
};

// --- Slice Creator ---
export const createSupportSlice: StateCreator<
  SupportSlice,
  [],
  [],
  SupportSlice
> = (set) => ({
  ...initialSupportState,

  openSheet: (articleId) =>
    set({
      isSheetOpen: true,
      sheetArticleId: articleId,
    }),

  closeSheet: () =>
    set({
      isSheetOpen: false,
      sheetArticleId: null,
    }),

  setSheetArticleId: (articleId) =>
    set({
      isSheetOpen: true,
      sheetArticleId: articleId,
    }),
});

// --- Selectors ---
export const support = {
  sheet: (s: SupportSlice) => ({
    isOpen: s.isSheetOpen,
    articleId: s.sheetArticleId,
    open: s.openSheet,
    close: s.closeSheet,
    setArticleId: s.setSheetArticleId,
  }),
};

